import { render } from "./AddModalValidationQueue.vue?vue&type=template&id=d0f63c32&ts=true"
import script from "./AddModalValidationQueue.vue?vue&type=script&lang=ts"
export * from "./AddModalValidationQueue.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__